import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { SubscriptionTopics } from '../../../../@api/client-api';

@Component({
  selector: 'newsletter-subscription-topics',
  templateUrl: './subscription-topics.component.html',
  styleUrl: './subscription-topics.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriptionTopicsComponent {
  @Input() public topics?: SubscriptionTopics = {};
  @Output() topicsChange = new EventEmitter<SubscriptionTopics>();

  changed() {
    this.topicsChange.emit(this.topics);
  }

}
